import DashboardBlock from './DashboardBlock'

export default DashboardBlock
